import React from "react";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { useHookstate } from "@hookstate/core";
import { currentInstallation } from "../ScrbTools";
import { PropTypes } from "prop-types";
import { I18n } from "aws-amplify";

Facturation.propTypes = {
    editable: PropTypes.bool.isRequired,
};

function Facturation(props) {

    const installation = useHookstate(currentInstallation);

    const onChange = (event) => {
        installation[event.target.name].set(event.target.value);
    }

    return (
        <div className="flex flex-column pt-3">
            <h2 className="text-xl font-semibold mb-4">
                <i className="fa-light fa-euro-sign" style={{ marginRight: '0.5rem' }}></i>
                {I18n.get("facturation")}
            </h2>
            <div className="pt-2">
                <FloatLabel>
                    <InputText
                        id="numCommandeClient"
                        name="numCommandeClient"
                        value={installation.get().numCommandeClient || ""}
                        onChange={onChange}
                        className="w-full"
                        autoComplete="off"
                        disabled={!props.editable}
                        maxLength={50}
                    />
                    <label htmlFor="numCommandeClient">{I18n.get("numCommandeClient")}</label>
                </FloatLabel>
            </div>
        </div>
    );
};

export default Facturation;
